import get from 'lodash/get';

import { GET_BOTTOM_SHEET_RESPONSE } from 'actions/userIncentives';
import { GET_VIEWABLE_BASKETS_V3_RESPONSE } from 'lib/constants/v3Actions';
import { transformMealForBottomSheet } from 'services/RequestService/helpers';

const initialState = {};

const initializeModalMeals = (currentMenusData, menuSlugs) => {
  const menusHash = menuSlugs.reduce((hash, slug) => ({ ...hash, [slug]: [] }), {});

  return {
    ...menusHash,
    ...currentMenusData,
  };
};

const addModalMealsForMenu = (currentMenusData, menuSlug, bottomSheet) => ({
  ...currentMenusData,
  [menuSlug]: {
    modalMeals: bottomSheet.modalMeals.map(mm => transformMealForBottomSheet(mm)),
    modalMealsCategory: bottomSheet.modalMealsCategory,
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_VIEWABLE_BASKETS_V3_RESPONSE:
      return initializeModalMeals(
        state,
        action.response.weeklyBaskets.map(wb => wb.menuSlug)
      );
    case GET_BOTTOM_SHEET_RESPONSE:
      return addModalMealsForMenu(
        state,
        action.response.userIncentives.menuSlug,
        action.response.userIncentives.bottomSheet
      );
    default:
      return state;
  }
};

export const selectModalMealsForMenu = (state, slug) => get(state, [slug, 'modalMeals'], []);
